'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _mobileSearchMenu = require('../actions/mobile-search-menu');

var INITIAL_STATE = {
	open: false,
	showRefineCategoryMenu: false,
	refineCategory: null,
	selectedMenuItem: 'keyword',
	selectedKeyword: null,
	selectedLocation: null,
	selectedInsurer: null,
	selectedParentSpecialty: null,
	keywords: null,
	locations: null,
	insurers: null,
	usingNearMe: null,
	findingLocation: null,

	showAdvancedOptions: false,
	selectedAdvancedOption: ''
};

var mobileSearchMenu = function mobileSearchMenu(state, action) {
	switch (action.type) {
		case _mobileSearchMenu.OPEN:
			return Object.assign({}, state, { open: true });
		case _mobileSearchMenu.CLOSE:
			return Object.assign({}, state, INITIAL_STATE);
		case _mobileSearchMenu.SELECT_CATEGORY:
			return Object.assign({}, state, { selectedMenuItem: action.selectedItem });
		case _mobileSearchMenu.SHOW_REFINE_OPTIONS:
			return Object.assign({}, state, { showRefineCategoryMenu: true, refineCategory: action.selectedRefineCategory });
		case _mobileSearchMenu.SELECT_REFINE_OPTION:
			{
				var selectedCategory = 'selected' + state.refineCategory.charAt(0).toUpperCase() + state.refineCategory.slice(1);
				var selectedOption = _extends({}, action.selectedOption, {
					type: action.selectedOption.type === 'health_check' ? 'healthCheck' : action.selectedOption.type
				});
				var newState = {
					showRefineCategoryMenu: false,
					refineCategory: null,
					selectedParentSpecialty: null
				};
				newState[selectedCategory] = selectedOption;
				return Object.assign({}, state, newState);
			}
		case _mobileSearchMenu.EXPAND_PARENT_CATEGORY:
			return Object.assign({}, state, { selectedParentSpecialty: action.parentKeyword });
		case _mobileSearchMenu.LOCATION_NEAR_ME_FOUND:
			return Object.assign({}, state, { showRefineCategoryMenu: false, refineCategory: null });
		case _mobileSearchMenu.CLEAR_SELECTED_MENU_ITEM:
			return Object.assign({}, state, { selectedMenuItem: null, selectedKeyword: null, selectedLocation: null, selectedInsurer: null });
		case _mobileSearchMenu.CLEAR_SELECTED_REFINE_CATEGORY:
			return Object.assign({}, state, { showRefineCategoryMenu: false, refineCategory: null, selectedParentSpecialty: null });
		case _mobileSearchMenu.CLEAR_SELECTED_PARENT_SPECIALTY:
			return Object.assign({}, state, { selectedParentSpecialty: null });

		case _mobileSearchMenu.TOGGLE_ADVANCED_OPTIONS:
			return _extends({}, INITIAL_STATE, { showAdvancedOptions: !state.showAdvancedOptions });
		case _mobileSearchMenu.SELECT_ADVANCED_OPTION:
			return _extends({}, state, { selectedAdvancedOption: action.option });
		default:
			return state || INITIAL_STATE;
	}
};

exports.default = mobileSearchMenu;


//////////////////
// WEBPACK FOOTER
// ./node_modules/doctify-global-redux/lib/reducers/mobile-search-menu.js
// module id = 1687
// module chunks = 0